import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import './App.css';
import Header from './components/Header';
import { AuthProvider } from './contexts/AuthContext';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BuildingProjectPage from './pages/BuildingProjectPage';
import GalleryPage from './pages/GalleryPage';
import ChurchActivitiesPage from './pages/ChurchActivitiesPage';
import TestimoniesPage from './pages/TestimoniesPage';
import ContactPage from './pages/ContactPage';
import AcademyPage from './pages/AcademyPage';
import ClinicPage from './pages/ClinicPage';
import RehabPage from './pages/RehabPage';
import ActsFellowshipPage from './pages/ActsFellowshipPage';
import ResourcesPage from './pages/ResourcesPage';
import DonatePage from './pages/DonatePage';
import AdminPage from './pages/AdminPage';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

const AdminLayoutContainer = styled.div`
  min-height: 100vh;
  background-color: #d4af37;
`;

const MainLayout = ({ children }) => (
  <AppContainer>
    <Header />
    <MainContent>{children}</MainContent>
    <Footer />
  </AppContainer>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <AuthProvider>
              <AdminLayoutContainer>
                <AdminPage />
              </AdminLayoutContainer>
            </AuthProvider>
          }
        />

        <Route
          path="/*"
          element={
            <MainLayout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/buildingproject" element={<BuildingProjectPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/churchactivities" element={<ChurchActivitiesPage />} />
                <Route path="/testimonies" element={<TestimoniesPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/school" element={<AcademyPage />} />
                <Route path="/clinic" element={<ClinicPage />} />
                <Route path="/rehab" element={<RehabPage />} />
                <Route path="/actsFellowship" element={<ActsFellowshipPage />} />
                <Route path="/training" element={<ResourcesPage />} />
                <Route path="/donate" element={<DonatePage />} />
              </Routes>
            </MainLayout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
